import {keyCodes} from '../../../lib/key-codes';
import {playShutterSound, animateArea, createDrawingSurface, createCanvas, createRoiHandler} from './roi-helper-methods';

/**
 * Coordinates the capturing of a region of interest. Given a viewport and settings, this class
 * will create a drawing surface suitable for allowing user interaction, create the appropriate
 * Roi capture mechanism (one of several RoiHandlers). It defers control to the RoiHandler during
 * the capture phase and returns it to the caller once the RoiHandler indicates completion. It
 * also cleans up after itself when done.
 */
export class RegionOfInterest {
  constructor (eventChannel, renderer) {
    this.eventChannel = eventChannel;
    this.renderer = renderer;
  }

  /**
     * @param viewport (object) - The viewport where the drawing will be attached.
     * @param settings (object) - Report settings extracted from user preferences.
     */
  draw (viewport, settings) {
    const viewportElement = viewport.vpDivGet('outer')[0];
    const canvas = createCanvas(viewportElement, settings);
    const surface = createDrawingSurface(this.renderer, canvas, viewportElement);
    const roiHandler = createRoiHandler(this.eventChannel, viewport, settings);

    // Provide definition for event handler that can be cleaned up when done.
    const escapeKeyHandler = (e) => {
      if (e.keyCode === keyCodes.escape) {
        this.eventChannel.trigger('drawing:user-cancelled');
        cleanup();
      }
    };

    // Clean up. Call when done.
    const cleanup = () => {
      document.removeEventListener('keyup', escapeKeyHandler);
      turnOffEventChannel();
      this.renderer.removeSurface(surface);

      // NOTE: IE depends on browser-compatibility.js for the call to {domElement}.remove()
      canvas.remove();
    };

    // Setup event listeners.
    const turnOffEventChannel = this.eventChannel.on('drawing:user-action-complete', async (rectangle) => {
      if (rectangle.area <= 0) {
        return;
      }

      playShutterSound();
      await animateArea(surface, rectangle);
      cleanup();
    });
    document.addEventListener('keyup', escapeKeyHandler);

    // Now that everything's configured, fire it up.
    roiHandler.init(surface);
    this.renderer.start();
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/RegionOfInterest.js